import { notice } from "JS/utils/notice";

export default class UsePoints {
     
    /**
     * @type {HTMLElement}
     */
    inputUsePoints;

     /**
     * @type {string}
     */
    pageType;

    /**
     * @type {Object}
     */
    mainPageObj;

    /**
     * 
     * @param {string} pageType 
     * @param {mainPageObj} Object
     */
    constructor(pageType, mainPageObj = null) {
        this.pageType = pageType;

        if (pageType == 'checkout' && !document.querySelector('.checkout-template__summary')) {
            return;
        }

        this.mainPageObj = mainPageObj;

        this.init();
    }

    init() {
        const inputElm = document.querySelector('input[name="use_points"]');
        if (!inputElm) {
            return false;
        }
        this.inputUsePoints = inputElm 
        this.inputUsePoints.addEventListener('change', this._processingPoints);
    }

    _processingPoints = (e) => {
        
        const parentContainer = this.pageType == 'cart' ? this.inputUsePoints.closest('.cart-payment') : document.querySelector('.checkout-template__summary');
        parentContainer.classList.add('loading');

        const formData = new FormData();
        formData.append('action', 'ref_use_points');
        formData.append('use_points', this.inputUsePoints.checked);
        formData.append('page', this.pageType);

        fetch(backendData.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then((resp) => resp.json())
            .then((response) => {
                if (!response.success) {
                    notice(response.data, 'error');
                    return;
                }

                const {
                    inner_html,
                    message,
                    use_points,
                } = response.data;

                if (use_points) {
                    notice(message);
                } else {
                    notice(message);
                    this.inputUsePoints.checked = false;
                }

                if (this.pageType == 'cart') {
                    this.mainPageObj.couponForm.replaceCartProcess(inner_html);
                } else {
                    parentContainer.outerHTML = inner_html;
                    this.mainPageObj.coupon.init();
                }
                
                this.init();

            })
            .catch((error) => {
                notice(error, 'error');
            })
            .finally(() => {
                parentContainer.classList.remove('loading');
            });
        
    }
}